import contact from "@/data/contact.json"
const state={
    personal : contact.data,
    organization: contact.organization,
    display:true,
    activeTab: '0',
    selectedUser: '',
    selectedContact:{
		"id": 1,
      "activeTab": "0",
      "img": "user/2.png",
      "name": "Mark ",
      "lastName": "jecno",
      "email": "markjecno@gmail.com",
      "gender": "Male",
      "active": "active show",
      "mobile": "+0 1800 76855",
      "name1": "Mark",
      "name2": "jecno",
	}
};
const mutations={
    change:(state)=>{
    state.display = !state.display 
    },
   
    active:(state,payload)=>
    {
    state.activeTab = payload 
   
    },
    print:(state,payload)=>
    {
    state.selectedUser = payload 
   
    },
    SET_CONTACT(state,payload){
		state.selectedContact = payload
	},
};
const getters={
    display:(state)=>{return state.display},
    activeTab:(state)=>{return state.activeTab},
    selectedUser:(state)=>{return state.selectedUser}
};
const actions={
    change:(context)=>
	{
	context.commit('change');
	},
    active:(context,payload)=>
	{
	context.commit('active',payload);
	},
    setSelectedContact({commit},payload){
		commit('SET_CONTACT',payload)
	},
};
export default {
	namespaced: true,
	state,
	getters,
	actions,
	mutations
};